"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPropertyListingWrapper$ = exports.AreaPropertyListingWrapper$outboundSchema = exports.AreaPropertyListingWrapper$inboundSchema = void 0;
exports.areaPropertyListingWrapperToJSON = areaPropertyListingWrapperToJSON;
exports.areaPropertyListingWrapperFromJSON = areaPropertyListingWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areapropertylisting_js_1 = require("./areapropertylisting.js");
/** @internal */
exports.AreaPropertyListingWrapper$inboundSchema = z.object({
    attributes: areapropertylisting_js_1.AreaPropertyListing$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.AreaPropertyListingWrapper$outboundSchema = z.object({
    attributes: areapropertylisting_js_1.AreaPropertyListing$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPropertyListingWrapper$;
(function (AreaPropertyListingWrapper$) {
    /** @deprecated use `AreaPropertyListingWrapper$inboundSchema` instead. */
    AreaPropertyListingWrapper$.inboundSchema = exports.AreaPropertyListingWrapper$inboundSchema;
    /** @deprecated use `AreaPropertyListingWrapper$outboundSchema` instead. */
    AreaPropertyListingWrapper$.outboundSchema = exports.AreaPropertyListingWrapper$outboundSchema;
})(AreaPropertyListingWrapper$ || (exports.AreaPropertyListingWrapper$ = AreaPropertyListingWrapper$ = {}));
function areaPropertyListingWrapperToJSON(areaPropertyListingWrapper) {
    return JSON.stringify(exports.AreaPropertyListingWrapper$outboundSchema.parse(areaPropertyListingWrapper));
}
function areaPropertyListingWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPropertyListingWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPropertyListingWrapper' from JSON`);
}
//# sourceMappingURL=areapropertylistingwrapper.js.map